"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OVERRIDES_KEY = void 0;
exports.clearExperimentStorage = clearExperimentStorage;
exports.getExperimentOverrides = exports.experimentStates = void 0;
exports.getUserExperimentVariation = getUserExperimentVariation;
exports.hasTriggeredExperiment = hasTriggeredExperiment;
exports.setExperimentOverrides = void 0;
require("core-js/modules/es.error.cause.js");
require("core-js/modules/es.json.stringify.js");
require("core-js/modules/es.object.keys.js");
var _get2 = _interopRequireDefault(require("lodash/get"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _storage = require("../util/storage");
var _customExperimentEvents = require("../tracking/customExperiment/customExperimentEvents");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var EXP_STORAGE_KEY = 'zola_user_experiments';
var OVERRIDES_KEY = exports.OVERRIDES_KEY = 'zola_flag_overrides';

/**
 * Enum for test values.
 *
 * @readonly
 * @enum {string}
 * @memberof client
 */
var experimentStates = exports.experimentStates = {
  NOT_IN_TEST: 'NOT_IN_TEST',
  // A disabled experiment 
  TEST: 'TEST',
  // An enabled single variation experiment (used like a feature flag)
  CONTROL: 'TEST-0' // The control group of an enabled A/B/n experiment
};

/**
 * @param experimentName - Experiment name
 * @returns indicating if the user has been placed in the experiment
 * @memberof client
 */
function hasTriggeredExperiment(experimentName) {
  var storedExperiments = (0, _storage.getSessionStorage)(EXP_STORAGE_KEY);
  if (!storedExperiments) return false;
  var parsed = JSON.parse(storedExperiments);
  if (parsed) return Boolean(parsed[experimentName]);
  return false;
}

/**
 * Fires a Custom Experiment Viewed segment event and saves the experiment in session storage
 *
 * @param experimentName - Experiment name
 * @param variationKey - Experiment variation
 * @memberof client
 */
function triggerExperiment(experimentName, variationKey) {
  if (variationKey !== experimentStates.NOT_IN_TEST) {
    // Don't track the view for single-variation experiments (i.e. feature flags)
    if (variationKey !== experimentStates.TEST) {
      (0, _customExperimentEvents.trackCustomExperimentViewed)({
        experimentName: experimentName,
        variationKey: variationKey
      });
    }
    // Add to session storage
    var triggeredExperiments = JSON.parse((0, _storage.getSessionStorage)(EXP_STORAGE_KEY) || '{}') || {};
    triggeredExperiments[experimentName] = true;
    (0, _storage.setSessionStorage)(EXP_STORAGE_KEY, JSON.stringify(triggeredExperiments));
  }
}

/**
 * Fires a Custom Experiment Viewed segment event and saves the experiment in session storage
 *
 * @function getUserExperiments
 * @param experimentName - Experiment name
 * @param userContext - userContext for this user
 * @returns List of experiments for this user
 * @memberof client
 */
function getUserExperiments(experimentName, userContext) {
  return (0, _get2.default)(userContext, "user_experiments.".concat(experimentName), {});
}
/**
 * @param config - User experiment config
 * @memberof client
 */
function getUserExperimentVariation(_ref) {
  var experimentName = _ref.experimentName,
    userContext = _ref.userContext,
    fallbackValue = _ref.fallbackValue,
    _ref$triggerExperimen = _ref.triggerExperimentViewed,
    triggerExperimentViewed = _ref$triggerExperimen === void 0 ? false : _ref$triggerExperimen;
  var experimentState = getUserExperiments(experimentName, userContext);
  var variationKey = experimentState.variation_key;
  var usingFallbackValue = false;
  if (!variationKey) {
    variationKey = fallbackValue;
    usingFallbackValue = true;
  }
  var noStateError = new Error('No experiment state found, please ensure new experiments have a fallback config.');
  if (!variationKey) throw noStateError;
  // Make sure a user context is present so we don't fire prematurely.
  var userContextExists = !(0, _isEmpty2.default)(userContext);
  var shouldTriggerExperiment = !usingFallbackValue && !hasTriggeredExperiment(experimentName) && triggerExperimentViewed && userContextExists;
  if (shouldTriggerExperiment) {
    triggerExperiment(experimentName, variationKey);
  }
  return variationKey;
}

/**
 * Clear experiemnt storage
 *
 * @memberof client
 */
function clearExperimentStorage() {
  (0, _storage.deleteSessionStorage)(EXP_STORAGE_KEY);
}
var getExperimentOverrides = exports.getExperimentOverrides = function getExperimentOverrides() {
  return JSON.parse((0, _storage.getCookie)(OVERRIDES_KEY) || '{}') || {};
};
var setExperimentOverrides = exports.setExperimentOverrides = function setExperimentOverrides(experimentName, variation) {
  if (!experimentName) return;
  var flagOverrides = getExperimentOverrides();
  flagOverrides[experimentName] = variation;
  (0, _storage.setCookie)(OVERRIDES_KEY, JSON.stringify(flagOverrides));
};